export const DEFAULT_FUEL_ID = 'B7'
export const FUEL_DEFAULT_COLOR = '#E8E515'
export const GEOENTITY_HOTEL_CELL_TYPE = 'hotel'
export const GEOENTITY_FUEL_CELL_TYPE = 'fuels'
export const GEOENTITY_GENERIC_CELL_TYPE = 'generic'
